import style from './LoaderIcon.module.scss';

const LoaderIcon = ({ className = '' }) => <div className={`${style.loaderIcon} ${className}`}></div>;
export default LoaderIcon;
